import useTag from '~/client/hooks/feature/useTag';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import DepositButton from './DepositButton';

type Props = {
  cashierPath?: string;
  isDepositAgain?: boolean;
};

const DepositLink: FC<Props> = ({ isDepositAgain = false, cashierPath }) => {
  const { depositLabel, isVisible } = useDepositLink(isDepositAgain);

  if (!isVisible) {
    return null;
  }

  return <DepositButton text={depositLabel} cashierPath={cashierPath} />;
};

const useDepositLink = (isDepositAgain?: boolean) => {
  const depositTranslationKey = isDepositAgain
    ? 'cashier.deposit.again'
    : 'cashier.deposit';
  const depositLabel = useTranslation(depositTranslationKey);
  const isAmsUser = useTag('isAmsUser');
  const isVisible = !isAmsUser;

  return { depositLabel, isVisible };
};

export default DepositLink;
